module.exports = __webpack_public_path__ + "cafb008a7380f4dd97b7e0a4f2970e90.png";